module.exports = __webpack_public_path__ + "img/nature-12.93f6fa91.jpg";